export const ROUTES = {
  ALLTRANSACTION: '/allTransaction',
  ALLCREDIT: '/allcredit',
  ALLDEBIT: '/alldebit',
  AAJOURNEY: '/AAJOURNEY',
  DASHBOARD: '/dashboard',
  LANDING: '/landing',
  BUDGET: '/budget',
  GOALDETAILS: '/goalDetails',
};
